import { render, staticRenderFns } from "./TeacherSubject.vue?vue&type=template&id=52df567a&"
import script from "./TeacherSubject.vue?vue&type=script&lang=js&"
export * from "./TeacherSubject.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSubject.vue?vue&type=style&index=0&id=52df567a&prod&lang=css&"
import style1 from "./TeacherSubject.vue?vue&type=style&index=1&id=52df567a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports